module.exports = __webpack_public_path__ + "static/atlaskit-table-sorted-c5fb123960dd7fefaef0adfbac8db6b8.png";